module.exports = sourceStreamId =>
  (sourceStreamId === 'P2P' ? 'RELAYED' : 'ROUTED');
